export default {
  namespaced: true,

  state: {
    message: '',
    color: ''
  },

  getters: {},

  mutations: {
    SET_MESSAGE (state, value) {
      state.message = value
    },
    SET_COLOR (state, value) {
      state.color = value
    }
  },

  actions: {
    show ({ commit }, { message, color }) {
      commit('SET_MESSAGE', message)
      commit('SET_COLOR', color)
    }
  }
}
